var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconResetCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-512-512s229.23-512 512-512z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M170.633 511.998c0 188.52 152.815 341.332 341.334 341.332 188.516 0 341.332-152.812 341.332-341.332 0-188.518-152.817-341.334-341.332-341.334-188.518 0-341.334 152.815-341.334 341.334zM338.706 347.475c41.39-43.5 97.641-69.82 157.558-73.725s119.109 14.894 165.793 52.653 77.445 91.713 86.154 151.123c8.704 59.408-5.274 119.921-39.158 169.488-33.884 49.572-85.192 84.567-143.708 98.022-58.519 13.455-119.958 4.383-172.090-25.405-52.133-29.793-91.138-78.121-109.253-135.368s-14.013-119.215 11.491-173.574l59.904 33.28c-14.644 33.694-18.024 71.215-9.639 106.983s28.089 67.876 56.182 91.551c28.092 23.675 63.075 37.652 99.747 39.854s73.075-7.485 103.8-27.628c30.725-20.142 54.129-49.659 66.739-84.168 12.605-34.509 13.742-72.162 3.236-107.366s-32.092-66.079-61.548-88.034c-29.455-21.956-65.208-33.821-101.947-33.83v102.4l-173.261-96.256z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResetCircle);
export default __webpack_public_path__ + "static/media/icon-reset-circle.8290d11eeb1b6d4b801f6e92ae926cc4.svg";
export { ForwardRef as ReactComponent };